"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Image_1 = require("mobile/components/Image");
var smartimagesrc_1 = require("@ezbuy/smartimagesrc");
var link_1 = require("mobile/utils/link");
var url_1 = require("utils/url");
var tool_1 = require("../../tool");
var WithEZSpm_1 = require("components/WithEZSpm");
var mutil_Language_1 = require("../../../utils/mutil-Language");
var css_1 = require("../../../utils/css");
var s = require("./index.scss");
var MagicBanner = (function (_super) {
    __extends(MagicBanner, _super);
    function MagicBanner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getRenderDate = function (moduleDetail) {
            var banner, items;
            var singleBanner = moduleDetail.module.banner || (moduleDetail.module.banners && moduleDetail.module.banners[0]);
            if (!singleBanner) {
                return {
                    banner: null,
                    items: []
                };
            }
            singleBanner &&
                (banner = __assign(__assign({}, singleBanner), { img: singleBanner.img
                        ? smartimagesrc_1.makeImageUrls(mutil_Language_1.multilingualImgDisplay(singleBanner), {
                            online: true,
                            qnParams: {
                                w: 750
                            },
                            keepSize: true,
                            aliSize: 7.5
                        })[0]
                        : singleBanner.img }));
            items = moduleDetail.module.items;
            return {
                banner: banner,
                items: items
            };
        };
        return _this;
    }
    MagicBanner.prototype.genTSpmLinkByUrl = function (link, order) {
        if (link) {
            var _a = this.props, index = _a.index, hasTitle = _a.hasTitle, navFixed = _a.navFixed, moduleMap = _a.moduleMap;
            if (link[0] === "#") {
                tool_1.anchorPoint(moduleMap, link, hasTitle, navFixed);
            }
            else {
                var url = url_1.genPrmLink(link, { floor: index, position: order });
                link_1.clickJump(url);
            }
        }
    };
    MagicBanner.prototype.render = function () {
        var _this = this;
        var _a = this.props, moduleDetail = _a.moduleDetail, commonProps = _a.commonProps, addModuleMap = _a.addModuleMap, index = _a.index;
        var renderDate = this.getRenderDate(moduleDetail);
        var height = css_1.formatBannerSize({
            width: renderDate.banner && renderDate.banner.width,
            height: renderDate.banner && renderDate.banner.height
        }).height;
        return (React.createElement("div", { ref: function (node) {
                if (node) {
                    addModuleMap(index, node, "#" + commonProps.id);
                }
            } },
            React.createElement(React.Fragment, null, renderDate && renderDate.banner ? (React.createElement("div", { className: s.magicWrap, style: { height: height } },
                React.createElement(Image_1.default, { src: renderDate.banner.img, isLazyLoad: true, style: {
                        width: "100%"
                    }, useOriginSrc: true }),
                renderDate.items &&
                    renderDate.items.map(function (item, i) { return (React.createElement("a", { key: i, onClick: function () { return _this.genTSpmLinkByUrl(item.link.trim(), i + 1); }, className: s.link, style: {
                            width: (Number(item.width) > 100 ? 100 : item.width) + "%",
                            height: item.height + "%",
                            top: item.top + "%",
                            left: item.left + "%"
                        } })); }))) : null)));
    };
    return MagicBanner;
}(React.Component));
exports.default = WithEZSpm_1.default(MagicBanner);
